export const reminders = state => state.reminders.items

export const activeReminders = state => {
    return _.filter(reminders(state), item => moment(item.remind_at).isSameOrBefore(moment()))
}

export const snoozedReminders = state => {
    return _.filter(reminders(state), item => moment(item.remind_at).isAfter(moment()))
}

export const reminderTypeById = (state, getters) => id => {
    return _.find(getters.activeReminders, {id: parseInt(id)}) ? 'Active' : 'Snoozed'
}

export const reminderById = state => id => _.find(reminders(state), {id: parseInt(id) })

export const remindersByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let item = reminderById(state)(id)
        if (item) res.push(item)
        return res
    }, [])
}


export const remindersByReference = state =>
    (reference_type, reference_id) => {
        reference_id = parseInt(reference_id)
        return _.filter(reminders(state), {reference_type, reference_id}).reverse()
    }